import React from 'react';
import {
  SearchZoomIn,
  SearchZoomOut,
  // «Единичные» начертания поворота — круговая стрелка с наконечником;
  // безымянные RotateLeft/RotateRight в пакете рисуют квадрат с дугой,
  // по которому направление поворота не читается.
  RotateLeft1 as RotateLeft,
  RotateRight1 as RotateRight,
} from '@myua/icons/dist/linear24';
import { useImageControls } from './useImageControls';
export const ImageControls: React.FC<{ controller: ReturnType<typeof useImageControls> }> = ({
  controller,
}) => {
  return (
    <div className="gen-file-viewer__controls">
      <div className="gen-file-viewer__controls-button-group">
        <div
          className="gen-file-viewer__controls-button"
          onClick={(e) => {
            e.stopPropagation();
            controller.zoomOut();
          }}
        >
          <SearchZoomOut />
        </div>
        <div
          className="gen-file-viewer__controls-button"
          onClick={(e) => {
            e.stopPropagation();
            controller.reset('original');
          }}
        >
          {controller.zoomLevelString}
        </div>
        {controller.canZoomToFit && (
          <div
            className="gen-file-viewer__controls-button gen-file-viewer__controls-button-text"
            onClick={(e) => {
              e.stopPropagation();
              controller.reset('fit-if-possible');
            }}
          >
            Zoom to fit
          </div>
        )}
        <div
          className="gen-file-viewer__controls-button"
          onClick={(e) => {
            e.stopPropagation();
            controller.zoomIn();
          }}
        >
          <SearchZoomIn />
        </div>
      </div>
      <div className="gen-file-viewer__controls-button-group">
        <div
          className="gen-file-viewer__controls-button"
          onClick={(e) => {
            e.stopPropagation();
            controller.rotateLeft();
          }}
        >
          <RotateLeft />
        </div>

        <div
          className="gen-file-viewer__controls-button"
          onClick={(e) => {
            e.stopPropagation();
            controller.rotateRight();
          }}
        >
          <RotateRight />
        </div>
      </div>
    </div>
  );
};
